import AppLoginForm from '@js/components/auth/AppLoginForm.vue'
import AppAuthChecker from '@js/components/auth/AppAuthChecker.vue'
import AppRegisterForm from '@js/components/auth/AppRegisterForm.vue'
import AppResetPasswordForm from '@js/components/auth/AppResetPasswordForm.vue'
import AppForgotPasswordContainer from '@js/components/auth/forgot-password/AppForgotPasswordContainer.vue'
import AppAlumniChecker from '@js/components/auth/AppAlumniChecker.vue'

const authComponents = [
  AppLoginForm,
  AppAuthChecker,
  AppRegisterForm,
  AppResetPasswordForm,
  AppForgotPasswordContainer,
  AppAlumniChecker,
]

export default authComponents
